import React from 'react';
import { connect } from 'react-redux';
import {
  FormGroup,
  Label,
} from 'reactstrap';

class Toggle extends React.PureComponent {
  handleChange = ({ target }) => {
    const { dispatch } = this.props;
    const { id, checked } = target;

    dispatch({
      type: 'EDIT_SITE_THEME',
      id,
      value: checked,
    });
  };

  render() {
    const {
      values,
      id,
      label,
      saving,
      disabled,
    } = this.props;

    return (
      <FormGroup>
        <Label for={id} className="font-weight-bold me-2">
          {label}
        </Label>
        <input
          type="switch"
          id={id}
          name={id}
          label={values[id] ? 'Active' : 'Inactive'}
          checked={values[id]}
          disabled={disabled || saving}
          onChange={this.handleChange}
        />
      </FormGroup>
    );
  }
}

const mapStateToProps = (store) => ({
  saving: store.sites.saving,
  values: store.sites.values,
});

export default connect(mapStateToProps)(Toggle);
